







































import Vue, { PropType } from 'vue'
import { Client } from '@/api/Agency/agency.interface'
import { Dictionary } from 'vue-router/types/router'
import Card from '@/components/Card.vue'

export default Vue.extend({
  components: {
    appCard: Card,
  },
  props: {
    client: Object as PropType<Client>,
  },
  computed: {
    myData() {
      if (!this.client.uuid) return {}
      const data = {} as Dictionary<string>
      const fields = ['identity', 'first_name', 'last_name', 'email', 'phone']
      fields.forEach(field => {
        data[field] = (this.client as Client & { [key: string]: string })[field]
      })
      return data
    },
  },
})
